module.exports = __webpack_public_path__ + "img/file.357ec8c8.svg";